import { render, staticRenderFns } from "./RelatorioPerformanceRegiaoFiltroModalItemInputCliente.vue?vue&type=template&id=fda18382"
import script from "./RelatorioPerformanceRegiaoFiltroModalItemInputCliente.vue?vue&type=script&lang=js"
export * from "./RelatorioPerformanceRegiaoFiltroModalItemInputCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports